import React, { useState } from 'react';
import { reportApi } from '../../api/report.api';

const Reports: React.FC = () => {
  const [reportType, setReportType] = useState('EXPIRY');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');

  // ✅ FUNCTION INSIDE COMPONENT
  const handleDownload = async (type: 'pdf' | 'excel') => {
    try {
      const blob =
        type === 'pdf'
          ? await reportApi.downloadPdf({ reportType, fromDate, toDate })
          : await reportApi.downloadExcel({ reportType, fromDate, toDate });

      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${reportType}-report.${type === 'pdf' ? 'pdf' : 'xlsx'}`;
      a.click();
    } catch (err) {
      alert('Download failed');
    }
  };

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-6">Reports</h1>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <label>From Date</label>
          <input
            type="date"
            className="border p-2 w-full"
            onChange={e => setFromDate(e.target.value)}
          />
        </div>

        <div>
          <label>To Date</label>
          <input
            type="date"
            className="border p-2 w-full"
            onChange={e => setToDate(e.target.value)}
          />
        </div>

        <div>
          <label>Report Name</label>
          <select
            className="border p-2 w-full"
            value={reportType}
            onChange={e => setReportType(e.target.value)}
          >
            <option value="EXPIRY">Expiry Report</option>
            <option value="ASSIGNED">Assigned Assets</option>
            <option value="EXPIRED">Expired Assets</option>
            <option value="STOLEN">Stolen Assets</option>
          </select>
        </div>
      </div>

      <div className="mt-6 flex gap-4">
        <button
          className="bg-primary text-white px-4 py-2 rounded"
          onClick={() => handleDownload('pdf')}
        >
          Download PDF
        </button>

        <button
          className="bg-green-600 text-white px-4 py-2 rounded"
          onClick={() => handleDownload('excel')}
        >
          Download Excel
        </button>
      </div>
    </div>
  );
};

export default Reports;
